/* eslint-disable react/jsx-sort-props */
// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React from "react";
import { TextField } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

export default function AMAutoComplete({
  name,
  value: val,
  onChange,
  autoFocus,
  error,
  helperText,
  placeholder,
  label,
  variant,
  options,
  autoSelectSingleOption,
  ...rest
}) {
  const [open, setOpen] = React.useState(false);
  
  // Auto-select single option
  React.useEffect(() => {
    if (autoSelectSingleOption && options && options.length === 1 && (!val || val.toString().trim() === "")) {
      onChange(null, options[0], "select-option", name);
    }
  }, [options]);

  //= ========Create Filter Options=======================
  // this is optional you can use   <Autocomplete> without it ,but you will not be able to use <Autocomplete filterOptions=...>
  const filter = createFilterOptions({
    // matchFrom: 'start', ///To EnhancePerformance ** It make filter startsWith instead of contains
    limit: 500, // To EnhancePerformance  ** It makes the maximam rendered options even thou source have more items
    // ignoreAccents: false, //To EnhancePerformance
    stringify: (option) => `${option.textField} ${option.searchField}`,
  });
  //= ========END Create Filter Options=========================
  const handleSelectedIndexChange = (event, value, reason) => {
    onChange(event, value, reason, name);
  };

  const getValueObject = () => {
    if (val.toString().trim() === "") return null;
    if (options && options.length) {
      const selectedObj = options.find((x) => x.valueField == val);
      return selectedObj || val;
    } else return val;
  };
  return (
    <Autocomplete
      id={name}
      nbame={name}
      size="small"
      // fullWidth

      open={open}
      // Events
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      // onChange={props.onChange}//this way can't work because the eventTarget refers to [option] , so we can't get name from it
      onChange={handleSelectedIndexChange}
      options={options}
      value={getValueObject()}
      getOptionLabel={(option) =>
        option.textField ? option.textField : option.toString()
      }
      filterOptions={(options, params) => {
        if (params.inputValue) {
          params.inputValue = params.inputValue.trim();
        }
        const filtered = filter(options, params);

        // #region FilteredIds It Will be used in new reload request
        // const newFilteredIds = filtered.map((item) => item.valueField);
        //console.log("newFilteredIds", newFilteredIds);
        // if (
        //   JSON.stringify(filteredIds.sort()) !==
        //   JSON.stringify(newFilteredIds.sort())
        // ) {
        //   setFilteredIds(newFilteredIds);
        // }
        // #endregion

        // if (params.inputValue !== "") {
        //   if (filtered.length < 10) {
        //     if (params.inputValue !== loadMoreText) {
        //       setloadMoreText(params.inputValue);
        //     }
        //   }
        // }

        // if (!loadOnce) {
        //   filtered.push({
        //     loadAllData: true,
        //     valueField: "loadall",
        //     textField: "--Load All--",
        //   });
        // }

        // filtered.push({
        //   valueField: 's',
        //   textField: '--Advanced Search--'
        // });

        return filtered;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          error={error}
          margin="dense"
          fullWidth
          helperText={helperText}
          placeholder={placeholder}
          label={label}
          variant={variant || "outlined"}
          sx={{
            "& .MuiInputLabel-root": {
              fontWeight: "bold",
              // color: theme.palette.secondary.main,
            },
          }}
        />
      )}
    />
  );
}
